define('shoptheme/components/ui/tabs',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"json!shoptheme/etc/breakpoints.json",
	"enquire"
], function(
	$,
	_,
	Component,
	BEM,
	BreakPoints,
	enquire
) {
	var defaults = {};
	var instances = [];
	var isMobile = true;

	function refreshHeight() {
		_.forEach(instances, function(instance) {
			instance.refreshHeight();
		});
	}

	var debouncedRefreshHeight = _.debounce(refreshHeight, 100);

	var mobileActions = function() {
		_.forEach(instances, function(instance) {
			if (instance.block.is(":modifier(close-mobile)")) {
				instance.closeAll();
			}
		});

		debouncedRefreshHeight();
	};

	enquire.register('(min-width: ' + (BreakPoints.sm + 1) + 'px)', {
		match: function() {
			isMobile = false;

			_.forEach(instances, function(instance) {
				instance.resetCurrent();
			});

			debouncedRefreshHeight();
		},
		unmatch: function() {
			isMobile = true;

			mobileActions();
		}
	}, true);

	Validation.prototype.validate = _.wrap(Validation.prototype.validate, function(orig) {
		var result = orig.apply(this, arguments);

		if (!result) {
			setTimeout(refreshHeight, 1);
		}

		return result;
	});

	function Tabs(block, options) {
		this.block = $(block);
		this.options = $.extend({}, defaults, options);

		this.list = this.block.bemGetElements("list");
		this.tabs = this.block.bemGetElements("tab");
		this.contents = this.block.bemGetElements("tab-content");

		this.map = _.map(this.tabs, function(tab, i) {
			var tabElement = $(tab);

			return {
				tab: tabElement,
				content: tabElement.next("." + BEM.buildElementClassname("tabs", "tab-content"))
			};
		}, this);

		this.current = {
			tab: this.tabs.filter(":modifier(active)"),
			content: this.contents.filter(":modifier(active)")
		};

		this.init();

		instances.push(this);
	}

	Tabs.prototype = {
		block:		null,
		options:	null,
		list:		null,
		tabs:		null,
		contents:	null,
		current:	null,

		init: function() {
			this.tabs.on("click", _.bind(this._onTabClick, this));
			this.contents.on("gigaset.content.change", _.bind(this.refreshHeight, this));
			this.refreshHeight();
		},

		_onTabClick: function(e) {
			var tab = $(e.currentTarget),
				mapItem = _.find(this.map, function(item) {
					return item.tab.get(0) === tab.get(0);
				}),
				content = mapItem.content;

			if (e.target.nodeName.toUpperCase() === "A"
				|| tab.bemHasModifier("inactive")
			) {
				return true;
			}

			if (!isMobile) {
				this.current.tab.bemRemoveModifier("active");
				this.current.content.bemRemoveModifier("active");

				this.current.content.trigger("tab-content-inactive");
			}

			if (isMobile && tab.is(":modifier(active)")) {
				tab.bemRemoveModifier("active");
				content.bemRemoveModifier("active");
			} else {
				tab.bemAddModifier("active");
				content.bemAddModifier("active");
			}

			content.trigger("tab-content-active");


			//this.contents.filter(":modifier(active)").bemRemoveModifier("active");
			//this.tabs.filter(":modifier(active)").bemRemoveModifier("active");


			this.current = mapItem;

			_.defer(_.bind(this.refreshHeight, this));
		},

		refreshHeight: function() {
			var height = "auto";
			if (!isMobile) {
				height = this.list.outerHeight(true) + this.current.content.outerHeight(true);
			}

			this.block.css("height", height);
		},

		resetCurrent: function() {
			this.closeAll();

			this.current.tab.bemAddModifier("active");
			this.current.content.bemAddModifier("active");
		},

		closeAll: function() {
			this.tabs.bemRemoveModifier("active");
			this.contents.bemRemoveModifier("active");
		}
	};

	return Component.create({
		blocks:			null,

		$init: function() {
			this.blocks = BEM.block("tabs");
			this.blocks.each(function() {
				var block = $(this);
				new Tabs(block, block.data("tabs"));
			});

			$(window).on("resize", debouncedRefreshHeight);
			debouncedRefreshHeight();

			if (isMobile) {
				mobileActions();
			}
		},

		initAjax: function (block) {
			new Tabs(block, block.data('tabs'));
		}
	});
});
